<template>
  <div class="user white-box">
    <div class="user-title">个人中心</div>
    <div class="user-info fs14 animate">
      <div class="user-name">
        <i class="icon-user"></i>
        <div>
          <p>用户名<span class="edit-trigger" v-on:click="switchEdit">[ 编辑 ]</span></p>
          <p class="fs16">
            <span class="user-nickname" v-bind:style="{ opacity: isEdit ? 0 : 1 }">{{ userInfo.username }}</span>
            <input v-show="isEdit" class="edit-username" type="text" v-model="username" v-on:keyup.enter="submitNickname" v-on:blur="submitNickname" />
          </p>
        </div>
      </div>
      <div class="user-mobile">
        <i class="icon-mobile"></i>
        <div>
          <p class="fs14">登录手机号</p>
          <p class="fs16">{{ userInfo.phone }}</p>
        </div>
      </div>
      <div class="user-type">
        <i class="icon-type"></i>
        <div>
          <p>账户余额</p>
          <p class="fs16">￥{{ userInfo.balance/100 }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {ajax} from '@/api/global'

  export default {
    name: "UserInfo",
    props: [],
    data: function () {
      return {
        userInfo : {},
        isEdit : false,
        username : null
      }
    },
    methods: {
      submitNickname : function () {
        var self = this;
        self.switchEdit();
        self.userInfo.username = self.username;
        ajax({
          mock : {},
          url : 'api/user/info/save',
          data : {
            nickname : self.nickname
          },
          type : 'post',
          success : function (res) {

          }
        });
      },
      ajaxUserInfo : function () {
        var self = this;
        ajax({
          // mock : Mock.userInfo,
          url : 'api/app-service/userinfo',
          type : 'get',
          success : function (res) {
            self.userInfo = res.data;
            console.info(self.userInfo);
            self.username = res.data.username;
          }
        });
      },
      switchEdit : function () {
        this.isEdit = !this.isEdit;
      }
    },
    created: function () {
      console.info('user-info-init');
      this.ajaxUserInfo();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/UserInfo.vue